<template>
  <div class="edit-platform">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">申请其他充值</div>
    <div class="order-detail-basic">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" hide-required-asterisk label-width="100px" class="demo-ruleForm">
        <!-- <el-form-item label="支付日期:" prop="bankTradeDate">
          <el-date-picker v-model="ruleForm.bankTradeDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="金额:" prop="amount">
          <el-input type="number" v-model="ruleForm.amount" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="虚拟充值:" prop="bonus">
          <el-input v-model="image.png.bonus"></el-input>
        </el-form-item> -->
        <el-row>
          <el-col span="7">
            <el-form-item label="收款账户:">
              <el-select v-model="ruleForm.bankAccountId" placeholder="请选择" @change="bankAccountChange">
                <el-option v-for="item in bankList" :key="item.bankAccountId" :label="item.bankName" :value="item.bankAccountId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="4">
            <el-form-item label="账户号:" style="margin-left: 1px;">
              <el-input v-model.number="outOrderNo" type="number" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="交易单号:">
          <el-input v-model.number="ruleForm.outOrderNo" type="number" placeholder="请填写交易单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="支付凭证:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div class="recharge-ok">上传文件</div>
          </div>
          <div id="show_img">
            <img :src="ruleForm.voucher" alt="">
          </div>
          <p style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="ruleForm.remark" clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="edit-button" style="justify-content: space-between;padding-left:120px;">
        <span style="color:#F56C6C">其他充值：适用于当前银行卡没有实际收到钱，收款账户选择银行卡未收到款充值</span>
        <el-button type="primary" round @click="submitForm('ruleForm')" :loading="loading">申请充值</el-button>
      </div>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
<script>
import imgSrc from '@/assets/images/money.svg'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { chargeApply, bankAccountGetAll } from '@/api/epay'
import { storeQueryListByCode, storeQueryByStoreCode } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'edit-platform',
  components: {
    CombinedDialog
  },
  data () {
    // 校验充值金额
    var checkAmount = (rule, value, callback) => {
      // const regAmount = /^[1-9]\d*$/
      const regAmount = /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
      if (value === '') {
        callback(new Error('请输入充值金额'))
      } else if (regAmount.test(value)) {
        return callback()
      } else {
        // callback(new Error('请输入正整数(不包括0)'))
        callback(new Error('请输入正数且小数点后精度两位'))
      }
    }
    var bankAccountId = (rule, value, callback) => {
      if (this.ruleForm.amount !== '0' && !this.ruleForm.bankAccountId) {
        callback(new Error('请选择收款账户'))
      } else {
        callback()
      }
    }
    var outOrderNo = (rule, value, callback) => {
      if (this.ruleForm.amount !== '0' && !this.ruleForm.outOrderNo) {
        callback(new Error('请输入交易单号'))
      } else {
        callback()
      }
    }
    return {
      outOrderNo: '', // 账户号
      loading: false,
      awsSdk: null,
      show: false,
      storeName: '',
      ruleForm: {
        accountType: 'ACCT', // 需要充值的账户类型
        amount: '', // 充值金额
        bankAccountId: '', // 收款账户
        bankTradeDate: '', // 支付日期
        voucher: '', // 支付凭证
        // bonus: '',
        remark: '', // 备注
        // outSerialNo: '', // 交易单号
        paymentChannel: 'OFFLINE',
        storeId: '',
        originType: 'WEB',
        outOrderNo: ''// 交易单号
      },
      isChargeOther: true,
      rules: {
        // bankTradeDate: [
        //   { required: true, message: '请选择日期', trigger: 'change' }
        // ],
        amount: [
          { validator: checkAmount, trigger: 'change' }
        ],
        // ,
        // remark: [
        //   { required: true, message: '请填写备注', trigger: 'blur' }
        // ]
        // bonus: [
        //   { required: true, message: '请填写虚拟充值', trigger: 'blur' }
        // ],
        bankAccountId: [
          { validator: bankAccountId, trigger: 'change' }
        ],
        outOrderNo: [
          { validator: outOrderNo, trigger: 'blur' }
        ]
      },
      // date: '',
      code: '', // 平台号
      bankList: []
    }
  },
  watch: {
    // date (val) {
    //   if (val) {
    //     this.ruleForm.bankTradeDate = this.$moment(this.date).format('YYYY-MM-DD')
    //   } else {
    //     this.ruleForm.bankTradeDate = ''
    //   }
    // }
    code () {
      this.show = false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getBankList()
  },
  methods: {
    // 选择银行
    bankAccountChange (val) {
      console.log(val)
      let findBank = this.bankList.find(res => res.bankAccountId === val)
      this.ruleForm.bankAccountId = val
      this.outOrderNo = findBank.cardNo
    },
    // 获取收款账户列表
    getBankList () {
      bankAccountGetAll().then(res => {
        this.bankList = res.data.data
      })
    },
    // 验证平台
    verifyStore () {
      this.code = this.code.replace(/\s*/g, '')
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      storeQueryByStoreCode(this.code).then(res => {
        if (res.data.data.exist) {
          this.ruleForm.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    submitForm (formName) {
      if (!this.show) {
        this.$message.error('请验证平台')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (!this.ruleForm.outOrderNo) {
          //   this.$message({
          //     message: '请填写交易单号',
          //     type: 'error'
          //   })
          //   return
          // }
          if (!this.ruleForm.voucher) {
            this.$message({
              message: '请上传支付凭证',
              type: 'error'
            })
            return
          };
          if (!this.ruleForm.remark) {
            this.$message({
              message: '请填写备注',
              type: 'error'
            })
            return
          };
          this.ruleForm.bankTradeDate = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
          console.log(this.ruleForm)
          this.loading = true
          chargeApply(this.isChargeOther, this.ruleForm).then(res => {
            if (res.data.success) {
              this.$message({
                message: '申请成功',
                type: 'success'
              })
              this.$router.push({
                path: '/epay/vpayCharge'
              })
              this.loading = false
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    upload (e) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (e.target.files[0].size === 0) {
        this.$message.error('该图片是一个空文件夹，无法上传')
        loading.close()
        return
      }
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        loading.close()
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        loading.close()
        return
      }
      var file = e.target.files[0]
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        this.ruleForm.voucher = res
        loading.close()
      })
    },
    handleSelect (item) {
      this.ruleForm.storeId = item.id
    },
    querySearchAsync (queryString, cb) {
      let val = queryString.replace(/\s*/g, '')
      if (!val) {
        return
      }
      storeQueryListByCode(queryString).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
.edit-platform {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

@deep: ~">>>";
</style>
